import { createContext, useContext, useEffect, useMemo, useState } from "react";

import { CacheProvider } from "@emotion/react";

import { createEmotionCache } from "./createEmotionCache";

const DirectionContext = createContext({
  dir: "ltr",
  setDir: () => {},
});

export const useDirection = () => useContext(DirectionContext);

export const DirectionProvider = ({ children }) => {
  const [dir, setDir] = useState(() => {
    if (typeof document !== "undefined") {
      return document.documentElement.dir || "ltr";
    }
    return "ltr";
  });

  const isRtl = dir === "rtl";

  const cache = useMemo(() => createEmotionCache(isRtl), [isRtl]);

  useEffect(() => {
    document.documentElement.dir = dir;
  }, [dir]);

  return (
    <DirectionContext.Provider value={{ dir, setDir }}>
      <CacheProvider value={cache}>{children}</CacheProvider>
    </DirectionContext.Provider>
  );
};
